import React from "react"
import SearchResults from "../components/Header/SearchResults"

export default function SearchPage() {
  return <SearchResults />
}
